import { variationDatasheetButton } from "../modules/woo-variation-datasheet";
import { variationGalleryImage } from "../modules/woo-variation-gallery";

window.addEventListener('load', () => {
  variationDatasheetButton();
  variationGalleryImage();
});
